module.exports = __webpack_public_path__ + "media/images/NHC_sp_logo-ec07f6d491e8f59334ac89396742084e.png";